// document.addEventListener("DOMContentLoaded", function () {
//   // Step 1: Uncheck all radio buttons (forcefully)
//   const allRadios = document.querySelectorAll('input[type="radio"]');
//   allRadios.forEach(radio => {
//     radio.checked = false;

//     // Remove 'checked' attribute if present in HTML
//     if (radio.hasAttribute("checked")) {
//       radio.removeAttribute("checked");
//     }
//   });

//   // Optional: Remove selected variant if Shopify already set one
//   const variantJson = document.querySelector('[data-selected-variant]');
//   if (variantJson) {
//     try {
//       variantJson.textContent = '';
//     } catch (e) {}
//   }

//   // Step 2: Disable add-to-cart button initially
//   const addToCartBtn = document.querySelector('form[action^="/cart"] [type="submit"], .product-form__submit');
//   if (addToCartBtn) {
//     addToCartBtn.disabled = true;
//     addToCartBtn.classList.add('disabled');
//   }

//   // Step 3: Your logic — Pod vs Pool
//   const podLegendText = "Float Pods";
//   const poolLegendText = "Float Pool";

//   function findFieldsetByLegendText(legendText) {
//     const fieldsets = document.querySelectorAll("fieldset");
//     for (let i = 0; i < fieldsets.length; i++) {
//       const legend = fieldsets[i].querySelector("legend");
//       if (legend && legend.textContent.trim() === legendText) {
//         return fieldsets[i];
//       }
//     }
//     return null;
//   }

//   const podFieldset = findFieldsetByLegendText(podLegendText);
//   const poolFieldset = findFieldsetByLegendText(poolLegendText);

//   if (!podFieldset || !poolFieldset) return;

//   const podRadios = podFieldset.querySelectorAll("input[type=radio]");
//   const poolRadios = poolFieldset.querySelectorAll("input[type=radio]");

//   function checkIfAnyRadioSelected() {
//     const anySelected = [...podRadios, ...poolRadios].some(r => r.checked);
//     if (addToCartBtn) {
//       addToCartBtn.disabled = !anySelected;
//       addToCartBtn.classList.toggle('disabled', !anySelected);
//     }
//   }

//   podRadios.forEach(radio => {
//     radio.addEventListener("change", function () {
//       poolRadios.forEach(poolRadio => poolRadio.checked = false);
//       checkIfAnyRadioSelected();
//     });
//   });

//   poolRadios.forEach(radio => {
//     radio.addEventListener("change", function () {
//       podRadios.forEach(podRadio => podRadio.checked = false);
//       checkIfAnyRadioSelected();
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  // Reset selected variant
  const selectedVariantJson = document.querySelector('[data-selected-variant]');
  if (selectedVariantJson) {
    selectedVariantJson.textContent = '';
  }

  // Reset all radio buttons and group names
  const fieldsets = document.querySelectorAll('fieldset');
  fieldsets.forEach((fieldset, index) => {
    const radios = fieldset.querySelectorAll('input[type="radio"]');
    const legend = fieldset.querySelector('legend');

    if (legend) {
      const groupName = legend.textContent.trim().toLowerCase().replace(/\s+/g, "_") + "_group_" + index;

      radios.forEach(radio => {
        radio.name = groupName;
        radio.checked = false;
        radio.removeAttribute("checked");
      });
    }
  });

  // Disable Add to Cart
  const addToCartBtn = document.querySelector('form[action^="/cart"] [type="submit"], .product-form__submit');
  if (addToCartBtn) {
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }

  // Enable Add to Cart on any manual selection
  const allRadios = document.querySelectorAll('input[type="radio"]');
  allRadios.forEach(radio => {
    radio.addEventListener("change", () => {
      allRadios.forEach(otherRadio => {
        // If not in the same group, uncheck
        if (otherRadio.name !== radio.name) {
          otherRadio.checked = false;
        }
      });

      // Enable Add to Cart if any radio selected
      const anyChecked = Array.from(allRadios).some(r => r.checked);
      if (addToCartBtn && anyChecked) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('disabled');
      }
    });
  });
});
